import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ErrorHandlerModule, ErrorHandlerService } from '@inera/common';
import { SithsEidErrorHandlerService } from './siths-eid-error-handler.service';

@NgModule({
  imports: [CommonModule, ErrorHandlerModule],
  providers: [
    {
      provide: ErrorHandlerService,
      useClass: SithsEidErrorHandlerService
    },
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class ApiModule {}
